export default __webpack_public_path__ + "static/media/step-three.5a0e536d.svg";